import { theme } from "@suse-o11y/twin-migration";

import { HealthStateValue } from "~/models/dto";

import { Api } from "../../common/openapi";

export function healthStateToBackgroundColor(healthState: Api.HealthStateValue | HealthStateValue): string {
	switch (healthState) {
		case HealthStateValue.Critical:
		case Api.HealthStateValue.CRITICAL:
			return theme("colors.red.100");

		case HealthStateValue.Flapping:
		case Api.HealthStateValue.FLAPPING:
		case HealthStateValue.Deviating:
		case Api.HealthStateValue.DEVIATING:
			return theme("colors.orange.100");

		case HealthStateValue.Clear:
		case Api.HealthStateValue.CLEAR:
			return theme("colors.green.100");

		default:
			return theme("colors.graphite.100");
	}
}
